import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageSquareReply, Sparkles, Inbox } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDate } from "@/components/common";

export const followUpLink = (contactId, r) =>
  `/compose?contact=${contactId}&mode=ai&purpose=${encodeURIComponent("reply to their response")}&notes=${encodeURIComponent(`They replied on ${fmtDate(r.received_at)} with subject "${r.subject}" (to my email "${r.original_subject || ""}"). The content of their reply is not available — write a short, polite follow-up that thanks them for replying, without assuming what they said.`)}`;

export default function RepliesPanel({ contactId }) {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get(`/contacts/${contactId}/replies`).then((r) => setItems(r.data)).catch(() => setItems([])); }, [contactId]);
  if (!items) return null;
  return (
    <div className="space-y-2" data-testid="replies-panel">
      {items.length === 0 && (
        <p className="flex items-center gap-2 text-sm text-slate-500"><Inbox className="h-4 w-4" />No replies detected yet. Replies are detected in connected business mailboxes.</p>
      )}
      {items.map((r) => (
        <div key={r.id} className="rounded-xl border border-green-200 bg-green-50/50 p-3" data-testid={`reply-${r.id}`}>
          <div className="flex items-start justify-between gap-2">
            <div className="min-w-0">
              <p className="flex items-center gap-2 font-semibold"><MessageSquareReply className="h-4 w-4 shrink-0 text-green-700" /><span className="truncate">{r.subject || "(no subject)"}</span></p>
              <p className="text-xs text-slate-500">From {r.from} · {fmtDate(r.received_at)} · in {r.mailbox}</p>
              {r.original_subject && <p className="text-xs text-slate-400">In reply to: {r.original_subject}</p>}
            </div>
            <Link to={followUpLink(contactId, r)} data-testid={`reply-followup-${r.id}`} className="cd-btn-primary h-9 shrink-0 px-3"><Sparkles className="h-4 w-4" />Draft follow-up</Link>
          </div>
        </div>
      ))}
      {items.length > 0 && <p className="text-xs text-slate-400">Only sender, subject and time are read — open your inbox to read the full reply.</p>}
    </div>
  );
}
